import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import "./styles/themes/index.css";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./lib/queryClient";

if ("__TAURI_INTERNALS__" in window) {
  document.documentElement.dataset.runtime = "desktop";
}

createRoot(document.getElementById("root")!).render(
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <App />
      <Toaster />
    </TooltipProvider>
  </QueryClientProvider>
);
